export enum StudentAbsenceReason {
  Medical,
  Family,
}
